import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Layout from './components/Layout'
import Home from './pages/Home'

// Lazy-load non-critical pages for code splitting
const Products = lazy(() => import('./pages/Products'))
const ProductPsa = lazy(() => import('./pages/Product'))
const ProductWms = lazy(() => import('./pages/ProductWms'))
const Solutions = lazy(() => import('./pages/Solutions'))
const Pricing = lazy(() => import('./pages/Pricing'))
const PricingWms = lazy(() => import('./pages/PricingWms'))
const Trust = lazy(() => import('./pages/Trust'))
const Audit = lazy(() => import('./pages/Audit'))
const CaseStudy = lazy(() => import('./pages/CaseStudy'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const Privacy = lazy(() => import('./pages/Privacy'))
const NotFound = lazy(() => import('./pages/NotFound'))

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-navy-500">Loading...</div></div>}>
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Products */}
            <Route path="/products" element={<Products />} />
            <Route path="/products/psa" element={<ProductPsa />} />
            <Route path="/products/wms" element={<ProductWms />} />

            {/* Solutions */}
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:industry" element={<Solutions />} />

            {/* Pricing */}
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/pricing/psa" element={<Pricing />} />
            <Route path="/pricing/wms" element={<PricingWms />} />

            {/* Services */}
            <Route path="/services/audit" element={<Audit />} />

            {/* Case Studies */}
            <Route path="/case-study/:slug" element={<CaseStudy />} />

            {/* Other pages */}
            <Route path="/trust" element={<Trust />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </>
  )
}

export default App
